/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.business.units.rpc.BusinessUnitsService
 */

import type {
  ChirpAvroRpcDetails,
  Requestify,
  unhandledEnumCase,
  Default,
  HubspotMetadata,
} from 'rpc-client-utils';

export type BusinessUnitsChirpError = {
  errorType: ErrorType;
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
};

export type ErrorType = 'NOT_FOUND' | 'BAD_REQUEST' | unhandledEnumCase;

export type RpcBusinessUnit = {
  id: number;
  hubId: number;
  name: string;
  allUsersHaveAccess: boolean;
};

export type RpcUserDefaultBusinessUnit = {
  hubId: number;
  userId: number;
  defaultBusinessUnitId?: number;
  allBrandsDefault: Default<boolean>;
  createdAt: number;
  updatedAt: number;
};

export type CreateBusinessUnitRequest = {
  name: string;
  allUsersHaveAccess: Default<boolean>;
};

export type DeleteBusinessUnitRequest = { businessUnitId: number };

export type GetBusinessUnitByIdRequest = { businessUnitId: number };

export type SetPrimaryBrandIdRequest = { brandId: number };

export type SetUserDefaultBusinessUnitRequest = {
  businessUnitId?: number;
  allBrandsDefault: Default<boolean>;
};

export type UpdateBusinessUnitRequest = {
  businessUnitId: number;
  name: string;
  allUsersHaveAccess: Default<boolean>;
};

export type ClearUserDefaultBusinessUnitResponse = {};

export type DeleteBusinessUnitResponse = {};

export type GetBusinessUnitResponse = { businessUnit: RpcBusinessUnit };

export type GetBusinessUnitsResponse = {
  businessUnits: Default<RpcBusinessUnit[]>;
};

export type GetUserDefaultBusinessUnitResponse = {
  userDefaultBusinessUnit: RpcUserDefaultBusinessUnit;
};

export type PrimaryBrandIdResponse = { primaryBrandId: number };

export type SetUserDefaultBusinessUnitResponse = {
  userDefaultBusinessUnit: RpcUserDefaultBusinessUnit;
};

export type CausalChainLink = {
  coordinates: ChirpMethodCoordinates;
  errorClass: string;
  errorMessage?: string;
};

export type ChirpMethodCoordinates = { service: string; method: string };

export type GetBusinessUnitsResponseType = GetBusinessUnitsResponse;
export type GetBusinessUnitsErrorType = BusinessUnitsChirpError &
  HubspotMetadata;
export const getBusinessUnitsRpc: ChirpAvroRpcDetails<
  undefined,
  GetBusinessUnitsResponseType,
  GetBusinessUnitsErrorType,
  false
> = {
  serviceName: 'com.hubspot.business.units.rpc.BusinessUnitsService',
  rpcName: 'getBusinessUnits',
  auth: 'app',
  fingerprint: 'AAAAAAAAAABJPsKJsEy6ii8zu6odjm0u',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetBusinessUnitsByUserResponseType = GetBusinessUnitsResponse;
export type GetBusinessUnitsByUserErrorType = BusinessUnitsChirpError &
  HubspotMetadata;
export const getBusinessUnitsByUserRpc: ChirpAvroRpcDetails<
  undefined,
  GetBusinessUnitsByUserResponseType,
  GetBusinessUnitsByUserErrorType,
  false
> = {
  serviceName: 'com.hubspot.business.units.rpc.BusinessUnitsService',
  rpcName: 'getBusinessUnitsByUser',
  auth: 'app',
  fingerprint: 'AAAAAAAAAABJPsKJsEy6ii8zu6odjm0u',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetBusinessUnitByIdRequestType =
  Requestify<GetBusinessUnitByIdRequest>;
export type GetBusinessUnitByIdResponseType = GetBusinessUnitResponse;
export type GetBusinessUnitByIdErrorType = BusinessUnitsChirpError &
  HubspotMetadata;
export const getBusinessUnitByIdRpc: ChirpAvroRpcDetails<
  GetBusinessUnitByIdRequestType,
  GetBusinessUnitByIdResponseType,
  GetBusinessUnitByIdErrorType,
  false
> = {
  serviceName: 'com.hubspot.business.units.rpc.BusinessUnitsService',
  rpcName: 'getBusinessUnitById',
  auth: 'app',
  fingerprint: 'k0x-bN8romliylIDWjSKAy8zu6odjm0u',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type CreateBusinessUnitRequestType =
  Requestify<CreateBusinessUnitRequest>;
export type CreateBusinessUnitResponseType = GetBusinessUnitResponse;
export type CreateBusinessUnitErrorType = BusinessUnitsChirpError &
  HubspotMetadata;
export const createBusinessUnitRpc: ChirpAvroRpcDetails<
  CreateBusinessUnitRequestType,
  CreateBusinessUnitResponseType,
  CreateBusinessUnitErrorType,
  false
> = {
  serviceName: 'com.hubspot.business.units.rpc.BusinessUnitsService',
  rpcName: 'createBusinessUnit',
  auth: 'app',
  fingerprint: '1XKFcV-3UdRiylIDWjSKAy8zu6odjm0u',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type UpdateBusinessUnitRequestType =
  Requestify<UpdateBusinessUnitRequest>;
export type UpdateBusinessUnitResponseType = GetBusinessUnitResponse;
export type UpdateBusinessUnitErrorType = BusinessUnitsChirpError &
  HubspotMetadata;
export const updateBusinessUnitRpc: ChirpAvroRpcDetails<
  UpdateBusinessUnitRequestType,
  UpdateBusinessUnitResponseType,
  UpdateBusinessUnitErrorType,
  false
> = {
  serviceName: 'com.hubspot.business.units.rpc.BusinessUnitsService',
  rpcName: 'updateBusinessUnit',
  auth: 'app',
  fingerprint: 'BGiAMChHajNiylIDWjSKAy8zu6odjm0u',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type DeleteBusinessUnitRequestType =
  Requestify<DeleteBusinessUnitRequest>;
export type DeleteBusinessUnitResponseType = DeleteBusinessUnitResponse;
export type DeleteBusinessUnitErrorType = BusinessUnitsChirpError &
  HubspotMetadata;
export const deleteBusinessUnitRpc: ChirpAvroRpcDetails<
  DeleteBusinessUnitRequestType,
  DeleteBusinessUnitResponseType,
  DeleteBusinessUnitErrorType,
  false
> = {
  serviceName: 'com.hubspot.business.units.rpc.BusinessUnitsService',
  rpcName: 'deleteBusinessUnit',
  auth: 'app',
  fingerprint: 'qexkAPIoGcowdTtUStoo3C8zu6odjm0u',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetUserDefaultBusinessUnitResponseType =
  GetUserDefaultBusinessUnitResponse;
export type GetUserDefaultBusinessUnitErrorType = BusinessUnitsChirpError &
  HubspotMetadata;
export const getUserDefaultBusinessUnitRpc: ChirpAvroRpcDetails<
  undefined,
  GetUserDefaultBusinessUnitResponseType,
  GetUserDefaultBusinessUnitErrorType,
  false
> = {
  serviceName: 'com.hubspot.business.units.rpc.BusinessUnitsService',
  rpcName: 'getUserDefaultBusinessUnit',
  auth: 'app',
  fingerprint: 'AAAAAAAAAACRh3A9bZ7U-S8zu6odjm0u',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type SetUserDefaultBusinessUnitRequestType =
  Requestify<SetUserDefaultBusinessUnitRequest>;
export type SetUserDefaultBusinessUnitResponseType =
  SetUserDefaultBusinessUnitResponse;
export type SetUserDefaultBusinessUnitErrorType = BusinessUnitsChirpError &
  HubspotMetadata;
export const setUserDefaultBusinessUnitRpc: ChirpAvroRpcDetails<
  SetUserDefaultBusinessUnitRequestType,
  SetUserDefaultBusinessUnitResponseType,
  SetUserDefaultBusinessUnitErrorType,
  false
> = {
  serviceName: 'com.hubspot.business.units.rpc.BusinessUnitsService',
  rpcName: 'setUserDefaultBusinessUnit',
  auth: 'app',
  fingerprint: 'wuyfijlM7YqhVq1CVimUDC8zu6odjm0u',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type ClearUserDefaultBusinessUnitResponseType =
  ClearUserDefaultBusinessUnitResponse;
export type ClearUserDefaultBusinessUnitErrorType = BusinessUnitsChirpError &
  HubspotMetadata;
export const clearUserDefaultBusinessUnitRpc: ChirpAvroRpcDetails<
  undefined,
  ClearUserDefaultBusinessUnitResponseType,
  ClearUserDefaultBusinessUnitErrorType,
  false
> = {
  serviceName: 'com.hubspot.business.units.rpc.BusinessUnitsService',
  rpcName: 'clearUserDefaultBusinessUnit',
  auth: 'app',
  fingerprint: 'AAAAAAAAAADw2f-_zZd8bC8zu6odjm0u',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetPrimaryBrandIdResponseType = PrimaryBrandIdResponse;
export type GetPrimaryBrandIdErrorType = BusinessUnitsChirpError &
  HubspotMetadata;
export const getPrimaryBrandIdRpc: ChirpAvroRpcDetails<
  undefined,
  GetPrimaryBrandIdResponseType,
  GetPrimaryBrandIdErrorType,
  false
> = {
  serviceName: 'com.hubspot.business.units.rpc.BusinessUnitsService',
  rpcName: 'getPrimaryBrandId',
  auth: 'app',
  fingerprint: 'AAAAAAAAAAAY1q-F1cS8si8zu6odjm0u',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type SetPrimaryBrandIdRequestType = Requestify<SetPrimaryBrandIdRequest>;
export type SetPrimaryBrandIdResponseType = PrimaryBrandIdResponse;
export type SetPrimaryBrandIdErrorType = BusinessUnitsChirpError &
  HubspotMetadata;
export const setPrimaryBrandIdRpc: ChirpAvroRpcDetails<
  SetPrimaryBrandIdRequestType,
  SetPrimaryBrandIdResponseType,
  SetPrimaryBrandIdErrorType,
  false
> = {
  serviceName: 'com.hubspot.business.units.rpc.BusinessUnitsService',
  rpcName: 'setPrimaryBrandId',
  auth: 'app',
  fingerprint: 'GQ4hvuZUJoQY1q-F1cS8si8zu6odjm0u',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};
